<section class="vc-admin-marketing-list">
  <app-admin-list-toolbar
    titleKey="ADMIN.MARKETING.CHANNELS.TITLE"
    descriptionKey="ADMIN.IA.MARKETING.DESCRIPTION"
    [showSearch]="true"
    searchPlaceholderKey="COMMON.SEARCH"
    [searchValue]="searchValue"
    (searchValueChange)="onSearch($event)"
  >
    <button
      toolbar-actions
      pButton
      type="button"
      icon="fas fa-plus"
      class="p-button-sm"
      [label]="'COMMON.ADD' | translate"
      (click)="router.navigate(['/administration', customer_route_param, 'marketing-channels', 'new'])"
    ></button>
  </app-admin-list-toolbar>

  @if (filteredMarketingChannels.length === 0) {
    <app-admin-state-panel
      mode="empty"
      titleKey="ADMIN.MARKETING.CHANNELS.EMPTY.TITLE"
      descriptionKey="ADMIN.MARKETING.CHANNELS.EMPTY.DESCRIPTION"
    ></app-admin-state-panel>
  } @else {
    <p-table
      [value]="filteredMarketingChannels"
      styleClass="Table"
      responsiveLayout="scroll"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[20, 40, 100]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'COMMON.NAME' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-marketingChannel>
        <tr>
          <td>{{ marketingChannel.name }}</td>
          <td>
            <app-admin-table-actions
              [manageRouterLink]="[
                '/administration',
                customer_route_param,
                'marketing-channels',
                marketingChannel.id
              ]"
              (delete)="confirmDelete(marketingChannel)"
            ></app-admin-table-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
